<template>
  <div class="tekenaar">
    <div class="item teklistnaam" style="opacity: 1;min-width: 180px;">
      <span class="tekst">{{ tekenaars.naam }}</span>
    </div>
    <div class="item teklistemail" style="min-width:300px;">
      <span class="tekst">{{ tekenaars.email }}</span>
    </div>
    <div class="item teklisttelefoonnummer" style="max-width:140px;">
      <span class="tekst">{{ tekenaars.telefoonnummer }}</span>
    </div>
    <div class="item teklistdisciplines" style="opacity: 1;max-width:140px;">
      <span
        class="discipline"
        v-for="discipline in discipliness"
        :key="discipline.index"
        :class="{
          pastel1: discipline == 'B',
          pastel2: discipline == 'W',
          pastel3: discipline == 'I',
          pastel4: discipline == 'E',
          pastel5: discipline == 'H',
          pastel6: discipline == 'P',
          pastel7: discipline == 'C',
          pastel9: discipline == 'N',
          pastel10: discipline == 'g'
        }"
        >{{ discipline }}</span
      >
    </div>
    <div class="item teklistbedrijfsnaam">
      <span class="tekst">{{ tekenaars.bedrijfsnaam }}</span>
    </div>
    <div class="item teklistwoonplaats">
      <span class="tekst">{{ tekenaars.woonplaats }}</span>
    </div>
    <div
      class="item teklisttekenprogramma"
      style="min-width: 260px;max-width:260px;"
    >
      <span class="tekst">{{ tekenaars.tekenprogramma }}</span>
    </div>
    <div
      class="item teklistaantalopdrachten"
      style="min-width:30px;width:30px;max-width:30px;"
    >
      <!-- <span class="discipline-orange">{{ opdrachtenVanTekenaar.length }}</span> -->
      <span class="discipline-orange">{{ tekenaars.aantalOpdrachten }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    tekenaar: Object
  },

  computed: {
    ...mapGetters(['allTekenaars', 'allOpdrachten']),

    tekenaars () {
      return this.tekenaar
    },
    discipliness () {
      let b = []
      if (Array.isArray(this.tekenaars.disciplines)) {
        this.tekenaars.disciplines.forEach(element => {
          b.push(element.charAt(0))
        })
      }
      return b
    },

    opdrachtenVanTekenaar () {
      return this.allOpdrachten.filter(opdracht => {
        if (this.tekenaars.id == opdracht.tekenaarsid) {
          return opdracht
        }
      })
    },
    aantalAfgerondeOpdrachten () {
      return this.opdrachtenVanTekenaar.filter(opdracht => {
        if (opdracht.status == 'Beindigd') {
          return opdracht
        }
      }).length
    }
  }
}
</script>

<style scoped>
.tekenaar {
  background-color: #fff;
  padding: 25px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  font-size: 15px;
  border-bottom: 1px solid #c5d8e3;
  border-left: 1px solid #c5d8e3;
  border-right: 1px solid #c5d8e3;
}
.tekenaar:hover {
  background-color: #ecf3fc;
  /* color: #fff; */
}
.item {
  /* opacity: 0.65; */
  color: #0b1125;
  opacity: 0.8;
  display: flex;
  overflow: hidden;
  align-items: center;
  min-width: 160px;
  /* max-width: 320px; */
  width: 18%;
  overflow-y: visible;
}

.tekst {
  white-space: nowrap;
}

.discipline {
  /* background-color: #E4ECFA; */
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  margin-right: -4px;
  font-size: 11px;
  color: #fff !important;
  border: 2px solid white;
}

.discipline-orange {
  background-color: #ff9323;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  font-size: 13px;
  color: white;
  border: 2px solid white;
}
</style>
